// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2325":"eb41a435","2427":"eb41a435","3846":"eb41a435","7551":"12f8bfba"}[chunkId] + ".chunk.css";
};